import axios from 'axios'

export const state = {
  finances: {},
}

export const getters = {
  listFinances (state) {
    return state.finances
  },
}

export const mutations = {
  SET_FINANCES (state, finances) {
    state.finances = finances
  },
  TOGGLE_SHOW_DETAIL (state, id) {
    state.finances.data.forEach((item, index) => {
      if (item.id === id) {
        item._showDetails = !item._showDetails;
        state.finances.data.splice(index, 1)
        state.finances.data.splice(index, 0, item)
      }
    });
  }
}

export const actions = {
  searchFinances({ commit }, params = {}) {
    return axios.get('/finance/search', { params })
  },
  getListFinances({ commit }, params = {}) {
    return axios.get('/finance', { params })
  },
  getFinances({ commit }, params = {}) {
    return axios.get('/finance', { params }).then(({ data }) => {
      return commit('SET_FINANCES', data)
    })
  },
  getFinance({ commit }, id) {
    return axios.get(`/finance/${id}`)
  },
  deleteFinancier({ commit }, id) {
    return axios.delete(`/finance/${id}`)
  },
  exportFinancesCsv({commit}, params = {}) {
    return axios.get('/finance/export', { params });
  },
  toggleDataDetails: function({commit}, index) {
    return commit('TOGGLE_SHOW_DETAIL', index)
  },
  createFinance({ commit }, finance) {
    const data = {
      name: finance.name,
      abn: finance.abn,
      acn: finance.acn,
      status: finance.status,
      term_id: finance.term ? finance.term.id : null,
      ak_contacts: finance.sale_reps ? parseUpdateSaleRep(finance.sale_reps) : [],
      addresses: finance.addresses ? parseAddresses(finance.addresses) : [],
      contacts: finance.contacts ? parseUpdateContacts(finance.contacts) : []
    }
    return axios.post('/finance', data)
  },
  updateFinance({commit}, finance) {
    finance.term_id = finance.term.id
    const data = {
      name: finance.name,
      abn: finance.abn,
      acn: finance.acn,
      status: finance.status,
      term_id: finance.term ? finance.term.id : null,
      ak_contacts: parseUpdateSaleRep(finance.ak_contacts),
      addresses: parseUpdateAddress(finance.addresses),
      contacts: parseUpdateContacts(finance.contacts)
    }
    return axios.put(`/finance/${finance.id}`, data)
  },
  importFinance({commit}, params = {}) {
    const formData = new FormData()
    formData.append('file', params.file, params.file.name)
    formData.append('type', params.type)
    formData.append('force_save', params.force_save)
    formData.append('download_error', params.download_error)
    const responseType = params.download_error ? 'blob' : 'json'
    return axios.post('/finance/import', formData, { responseType: responseType })
  },
  downloadImportFinancesTemplate({ commit }, params = {} ) {
    return axios.get(`/import/finance/download-template`, {responseType: 'blob'})
  },
}

function parseAddresses(addresses) {
  const arrayAddresses = []
  addresses.forEach((item) => {
    const address = {...item}
    address.types = item.types.map(type => type.name)
    arrayAddresses.push(address)
  })
  return arrayAddresses
}

function parseUpdateSaleRep(saleReps) {
  const arraySales = []
  saleReps.forEach((item) => {
    const saleRep = {...item}
    saleRep.staff_id = saleRep.staff ? saleRep.staff.id : null;
    saleRep.types = item.types ? item.types.map(type => type.name) : []
    arraySales.push(saleRep)
  })
  return arraySales
}

function parseUpdateAddress(addresses) {
  const arrayAddresses = []
  addresses.forEach((item) => {
    const address = {...item}
    address.country_id = address.country_id || (address.country && address.country.id)
    address.types = item.types ? item.types.map(type => type.name) : []
    arrayAddresses.push(address)
  })
  return arrayAddresses
}

function parseUpdateContacts(contacts) {
  const arrayContacts = []
  contacts.forEach((item) => {
    const contacts = {...item}
    if (contacts.role) {
      contacts.role_id = contacts.role.id
    }
    arrayContacts.push(contacts)
  })
  return arrayContacts
}
